import "./App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navigation from "./components/Navigation";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Experience from "./pages/Experience";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Preloader from "./components/Preloader";

// Import site config
import siteData from "./content/site.json";

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  // Get preloader config from JSON
  const preloaderEnabled = siteData.preloader?.enabled !== false;
  
  // Check if this is first visit in this session
  const hasShownPreloader = sessionStorage.getItem('preloaderShown') === 'true';
  const shouldShowPreloader = preloaderEnabled && !hasShownPreloader;
  
  const [showPreloader, setShowPreloader] = useState(shouldShowPreloader);
  const [appReady, setAppReady] = useState(!shouldShowPreloader);

  const handlePreloaderComplete = () => {
    sessionStorage.setItem('preloaderShown', 'true');
    setShowPreloader(false);
    setAppReady(true);
  };

  return (
    <div className="App">
      {/* Preloader - only renders on first visit in session */}
      {showPreloader && (
        <Preloader onComplete={handlePreloaderComplete} />
      )}
      
      {/* Main app content */}
      {appReady && (
        <BrowserRouter>
          <Navigation />
          <AnimatedRoutes />
          <Toaster />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
